Vivense = {};
Vivense.init = {};


Vivense.validateError = function (errorMessage,errorCode) {

    var invalidEmail = 1;
    var invalidPassword = 2;
    var genericErrors = 0;
    
    if(errorCode  == "undefined") {
        errorCode = genericErrors;
    }

    if(errorCode === invalidPassword ){
        var validationElm = $(".failed-login-wrapper");
        var validationInput = $(".login-email-input");
        validationElm.text(errorMessage);
        validationElm.addClass("failed-login");
        validationInput.addClass("validation-failed");
        $(".vivense-registration-page").append("<span class='generalErrorMessage'>" + errorMessage + "</span>");
    }

    // for password error and generic 
    else {
        var validationElm = $(".failed-login-wrapper-password");
        var validationInput = $(".login-password-input");
        validationElm.text(errorMessage);
        validationElm.addClass("failed-login-password");
        validationInput.addClass("validation-failed");
        $(".vivense-registration-page").append("<span class='generalErrorMessage'>" + errorMessage + "</span>");
    } 

};

Vivense.displayError = function (error) {

    var msg;

    if (error) {
        if ($.isArray(error)) {
            msg = error[0];
        } else {
            msg = error;
        }
    } else {
        msg = 'Bir hata oluştu.';
    }

    swal({
        'title': '',
        'text': msg,
        'type': 'error',
        'confirmButtonText': 'Tamam'
    });
};

Vivense.displaySuccess = function (successMsg) {

    var msg;

    if (successMsg) {
        if ($.isArray(successMsg)) {
            msg = successMsg[0];
        } else {
            msg = successMsg;
        }
    } else {
        msg = 'İşleminiz Gerçekleşti.';
    }

    swal({
        'title': '',
        'text': msg,
        'type': 'success',
        'confirmButtonText': 'Tamam'
    });
};

Vivense.ajaxLog = function(msg, error) {
    try {
        var logMsg = msg;
        if (error) {
            logMsg = msg + "\n\n" + error.stack;
        }
        jQuery.ajax('/ajax/log/log.php', {
            method: 'POST',
            data: logMsg,
            processData: false,
            contentType: 'text/plain'
        });
    } catch (e) {
        console.log(e);
    }
};

jQuery(document).ready(function () {


    var $ = jQuery;



    $(".kvkk-modal-content").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 300
    });




    $(".register-login").on("mouseenter", function () {
        $(".user-action-wrapper").addClass("popup-active");
    }).on("mouseleave", function () {
        $(".user-action-wrapper").removeClass("popup-active");
    });



    $(".showroom-location-container").hover(function () {
            $(".showroom-location-container .shwrm-desc").addClass("shw-area");
        },
        function () {
            $(".showroom-location-container .shwrm-desc").removeClass("shw-area");
        });


    $(".campaign-menu-container").hover(function () {
            $(".cmp-area").addClass("shw-area");
        },
        function () {
            $(".cmp-area").removeClass("shw-area");
        });

    // Show Coupon Modal on Registration
    if (parseInt(window.userId) !== 0 && Vivense.cookie.get('showCouponModal') == 1) {
        var couponPopup = $("#couponPopup");
        var couponCode = 'H' + parseInt(window.userId).toString(16).toUpperCase();
        couponPopup.find('#copiedText').val(couponCode);
        couponPopup.find('#copyToClipboard').click(function () {
            var aux = document.createElement("input");
            aux.setAttribute("value", couponCode);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
            $(this).text('Kod kopyalandı');
        });

        couponPopup.modal();
        Vivense.cookie.delete('showCouponModal');
    }

    $(".vvns-cart-update-product-popup__close").click(function(){
        $(".vvns-cart-update-product-popup-overlay").remove();
    });

    $(".cookieSettings").click(function(e){
        e.preventDefault();
    })

    // Wait for the DOM to be ready
    $(function() {

        function disableRegisterButton(){
            $('.vvs-snippet-subscription__button').prop('disabled', true);
        }

        function enableRegisterButton(){
            $('.vvs-snippet-subscription__button').prop('disabled', false);
        }

        $(".vvs-snippet-subscription__input input").on('input', function(e) {
            var target = $(e.target);
            target.val(function(i, v) {
                return v.toLowerCase();
            });
        });

        //Vvns Input Focus
        $('.vvs-snippet-subscription__input input').focus(function (){
            $(this).parent().addClass('active');
            $('.vvs-snippet-subscription__info-text').remove();
        });

        //Vvns Input Blur
        $('.vvs-snippet-subscription__input input').blur(function (){
            var inputValue = $(this).val();
            if ( inputValue == "" ) {
                $(this).parent().removeClass('active');
                $(this).parents('.vvns-input').removeClass('active');
            } else {
                $(this).parent().addClass('active');
            }
        });

        function removeSubscriptoninfotext(){
            setTimeout(function(){
                if ($('.vvs-snippet-subscription__info-text').length > 0) {
                    $('.vvs-snippet-subscription__info-text').remove();
                }
            }, 5000)
        }

        function handleRegisterResult(response){
            if (response.statusCode == 1) {
                console.log('başarılı');
                $(".vvs-snippet-subscription__input").append("<span class='vvs-snippet-subscription__info-text'>Mailini Başarıyla Kaydettik</span>")
                removeSubscriptoninfotext();

            } else if (response.statusCode == 2) {
                $(".vvs-snippet-subscription__input").append("<span class='vvs-snippet-subscription__info-text'>Bu Mail Adresi Sistemde Zaten Mevcut</span>")
                removeSubscriptoninfotext();

            } else if (response.statusCode == 3){
                $(".vvs-snippet-subscription__input").append("<span class='vvs-snippet-subscription__info-text'>Beklenmeye Bir Hata, Lütfen Daha Sonra Tekrar Deneyin.</span>")
                removeSubscriptoninfotext();
            }
        }

        var form = $("#vvns-subscription-form");

        var checkIsValid = function() {
            if (form.valid()) {
                enableRegisterButton();
            } else {
                disableRegisterButton();
            }
        }

        // Wait for the DOM to be ready
        $(function() {
            // Initialize form validation on the registration form.
            // It has the name attribute "registration"
            $("form[name='vvns-subscription-form']").validate({
                errorClass: "error fail-alert",
                validClass: "valid success-alert",

                // Specify validation rules
                rules: {
                    "jform[email1]": {
                        required: true,
                        email: true
                    },
                },

                onkeyup: checkIsValid,
                onclick: checkIsValid,
                messages: {
                    email: "lütfen geçerli bir e-posta adresi giriniz",
                },

                submitHandler: function(form) {
                    form.submit();
                },
            });
        });

        $("#subscribeBtn").click(function (event){

            event.preventDefault();
            disableRegisterButton();

            var formData = {
                email: $("#email").val(),
            };

            $.ajax({
                type: "POST",
                url: "/ajax/user/subscribe.php",
                data: formData,
                dataType: "json",
                encode: true,
                success: function (response) {
                    handleRegisterResult(response);
                },
                error: function () {
                    alert(formData);
                }
            })

        })
    });

});

